import { Component, Input, OnInit } from '@angular/core';
import { TRACKING } from '../../enums/trackingParts.enum';
import { TariffAdvisorService } from '../../services/tariff-advisor.service';

@Component({
    selector: 'bdo-haie-strom-teaser',
    templateUrl: './haie-strom-teaser.component.html',
    styleUrl: './haie-strom-teaser.component.scss',
    standalone: false
})
export class HaieStromTeaserComponent implements OnInit {
  @Input() productIds: Array<string>;
  public TRACKING = TRACKING;
  public isHaie = false;

  constructor(
    private tariffService: TariffAdvisorService
  ) { }

  ngOnInit(): void {
    this.isHaie = this.tariffService.isHaieTariff(this.productIds);
  }

}
